import { render, staticRenderFns } from "./support.page.vue?vue&type=template&id=5802e1eb&scoped=true&"
import script from "./support.page.vue?vue&type=script&lang=js&"
export * from "./support.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5802e1eb",
  null
  
)

export default component.exports